import { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import Button from "@mui/material/Button";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { getUserByBarcode } from "../../services/UserService";
import IconLoader from "../../components/IconLoader";

import isEmpty from "lodash-es/isEmpty";
import { doService } from "../../services/ServiceHelper";
import { showError, showSuccessHtml } from "../../components/ATPDialogs";
import { getUserEid } from "../../services/UserService";
import { doTardyQrScore } from "../../services/ScoreService";
import dayjs from "dayjs";

const TardyKiosk = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [_showProgress, setShowProgress] = useState(false);

  const [pageFocused, setPageFocused] = useState(document.hasFocus());

  const [_isLoaded, setIsLoaded] = useState(false);
  const [_studentId, setStudentId] = useState("");

  let _capturedCode = "";

  useEffect(() => {
    return initScanner();
  }, []);

  const initScanner = () => {
    const handleKeyDown = (event) => {
      // bail on error
      if (event.key == null) {
        return;
      }

      if (event.key === "Enter") {
        doExamineCode(_capturedCode);
        // process and reset
        _capturedCode = "";
        return;
      }

      // ignore modifier keys, only handle real characters
      if (event.key.length === 1) {
        const code = _capturedCode;
        _capturedCode += event.key;
      }

      // handle Backspace
      if (event.key === "Backspace") {
        console.log("Backspace");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    const handleFocus = () => setPageFocused(true);
    const handleBlur = () => setPageFocused(false);

    window.addEventListener("focus", handleFocus);
    window.addEventListener("blur", handleBlur);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("focus", handleFocus);
      window.removeEventListener("blur", handleBlur);
    };
  };

  const isSomethingFocused = () => {
    return document.hasFocus();
  };

  const doExamineCode = (capturedCode) => {
    if (capturedCode.length === 0) {
      return;
    }

    if (capturedCode.length < 5) {
      return;
    }

    setShowProgress(true);
    doService(getUserByBarcode(_school, _jwt, capturedCode), (result) => {
      setShowProgress(false);

      if (result.data == null) {
        showError(
          "Unable to Add Tardy Record",
          "Student ID not found: " + capturedCode,
        );
        return;
      }

      doCreateTardy(result.data);
    });
  };

  const doCreateTardy = (student) => {
    const teacherEid = getUserEid(_jwt)
    doService(
      doTardyQrScore(_school, _jwt, teacherEid, _school.tardyCategoryId, student.eid, "Tardy Kiosk"),
      (results) => {
        const student = results.data.student;
        const score = results.data.score;

        const html = `
          <table style="margin-left:auto;margin-right:auto">
            <tbody>
              <tr>
                <td style="font-weight:bold;text-align:right">Student:</td>
                <td style="text-align:left">${student.first_name} ${
                  student.last_name
                } (${student.grade})</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right;font-size:20px">Created On:</td>
                <td style="text-align:left">${dayjs(score.dt).format(
                  "MM/DD/YY hh:mm a",
                )}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right">Score Type:</td>
                <td style="text-align:left">${score.category_name}</td>
              </tr>
              <tr>
                <td style="font-weight:bold;text-align:right">Consequence:</td>
                <td style="text-align:left">${score.consequence_name}</td>
              </tr>
            </tbody>
          </table>
        `;

        _capturedCode = "";
        setStudentId("");
        showSuccessHtml(`Tardy Record Created`, html);
        return;
      },
      (detail) => {
        showError("Unable to Add Tardy Record", detail);
        return;
      },
    );
  };

  const onClickTardy = (studentEid) => {
    if (isEmpty(_studentId)) {
      showError("Please enter Student ID.");
      return;
    }
    doExamineCode(_studentId);
  };

  return (
    <>
      <DrawerAppBar
        disableLogout={true}
        showLogout={false}
        showHamburger={false}
      />

      <Container sx={{ mt: 1 }}>
        <Title text="Tardy Kiosk" showBack={false} />

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={11}>
            <Alert severity="info">
              Enter your Student ID or scan your ID badge to mark yourself as
              present.
              <br />
              This page must be the top page and clicked upon for a scanner to
              receiver the barcode content.
            </Alert>
          </Grid>
          <Grid item xs={1}>
            <IconLoader iconName="scanner" progress={_showProgress} />
          </Grid>
        </Grid>

        {pageFocused === true && (
          <Alert severity="success">
            You Can Scan Barcodes Now (page is focused)
          </Alert>
        )}
        {pageFocused === false && (
          <Alert severity="error">
            Page needs to be Clicked to scan barcodes.
          </Alert>
        )}

        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            Enter Student ID
          </AccordionSummary>
          <AccordionDetails>
            <InputLabel sx={{ mt: 1 }}>* Student ID</InputLabel>
            <Box display="flex" gap={1}>
              <TextField
                margin="dense"
                type="text"
                fullWidth
                size="small"
                onChange={(evt) => setStudentId(evt.target.value)}
                value={_studentId}
                sx={{ mt: 0 }}
              />
              <Button variant="contained" onClick={onClickTardy}>
                Submit
              </Button>
            </Box>
          </AccordionDetails>
        </Accordion>

        {isSomethingFocused()}
      </Container>
    </>
  );
};

export default TardyKiosk;
